import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { useAlertContext } from '@/contexts/AlertContext'

/**
 * Watches for route changes and clears alerts (including persistent ones).
 * Must be rendered inside both a Router and AlertProvider context.
 */
export function AlertRouteWatcher() {
  const location = useLocation()
  const previousPathnameRef = useRef(location.pathname)
  const { resetAlerts } = useAlertContext()

  useEffect(() => {
    if (previousPathnameRef.current !== location.pathname) {
      resetAlerts()
      previousPathnameRef.current = location.pathname
    }
  }, [location.pathname, resetAlerts])

  return null
}
